export const Card = {
  Platinum: 'the-platinum-card',
  Centurion: 'the-centurion-card',
};
